import { StandardEvents } from '@shopify/events';

/**
 * Keeps the bag count in the mobile tab bar honest.
 *
 * The bar is server-rendered with cart.item_count, so it is already correct
 * on a cold load. Two things can make it stale: an add to cart that never
 * reloads the page, and a back-forward-cache restore. This listens for
 * exactly those two and nothing else. There is no scroll listener and no
 * observer; the bar does not move.
 *
 * The count is text, not an animation, so reduced motion needs no branch.
 */

// Theme is a top-level `const` (scripts.liquid:287): a global lexical binding, never a window property.
const cartUrl = () => `${(typeof Theme !== 'undefined' && Theme?.routes?.cart_url) || '/cart'}.js`;

/** @param {number} count */
function paint(count) {
  const link = document.querySelector('[data-el-bag-link]');
  const bubble = document.querySelector('[data-el-bagcount]');
  if (!link || !bubble) return;

  const n = Number.isFinite(count) && count > 0 ? Math.trunc(count) : 0;
  bubble.textContent = n > 99 ? '99+' : String(n);
  bubble.hidden = n === 0;

  const template = link.dataset.elBagLabel;
  if (template) {
    const unit = n === 1 ? 'item' : 'items';
    const label = template.replace('[count]', String(n)).replace('[items]', unit);
    link.setAttribute('aria-label', label);
  }
}

async function refresh() {
  try {
    const response = await fetch(cartUrl(), { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    paint(cart?.item_count);
  } catch {
    // Leave the server-rendered count alone. A wrong number is worse than a stale one.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const promise = event?.promise;
  if (!promise) {
    refresh();
    return;
  }
  promise
    .then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (typeof count === 'number') paint(count);
      else refresh();
    })
    .catch(() => refresh());
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refresh();
});
